export  const language = {
  zh: {
    'Exceed Max Quantity': '超过最大可购买量',
    'Exceed Stock': '超过销售库存',
  },
  en: {
    'Exceed Max Quantity': 'Exceed Max Quantity',
    'Exceed Stock': 'Exceed Stock',
  }
};
